var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group align-start"},[_c('router-link',{directives:[{name:"test",rawName:"v-test:button",value:('go to market'),expression:"'go to market'",arg:"button"}],attrs:{"to":{
      name: _vm.routeNameModalClientEvents,
      params: {
        eventType: 'go-to-market',
        projectId: 'new',
      }
    }}},[_c('tf-button',{attrs:{"icon":"exchange-alt","size":"large","type":"secondary"},on:{"click":function($event){return _vm.$TF.Analytics.trackEvent('Go to market start')}}},[_vm._v(" Go to market ")])],1),_c('router-link',{directives:[{name:"test",rawName:"v-test:button",value:('renewal'),expression:"'renewal'",arg:"button"}],attrs:{"tag":_vm.canCollectRenewal ? 'a' : 'span',"to":_vm.canCollectRenewal
      ? {
        name: _vm.routeNameModalClientEvents,
        params: {
          eventType: 'collect-renewals',
          projectId: 'new',
        }
      }
      : {}}},[_c('tf-button',{attrs:{"disabled":!_vm.canCollectRenewal,"icon":"sync","size":"large","type":"primary"},on:{"click":function($event){return _vm.$TF.Analytics.trackEvent('Collect renewals start')}}},[_vm._v(" Collect renewals ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }